<template>
	<div class="container-fluid flex-column position-absolute justify-content-center h-100 main" id="deletePopup">
		<div class="container bg-light col-lg-8 col-md-8 col-xl-7 col-sm-8 p-5 popup">
			<div class="flex-column justify-content-center cont">
				<div class="title">вы действительно хотите удалить стример {{deleteStreamer.str}}?</div>
				<div class="container justify-content-around">
					<button class="btn btn-outline-danger" @click="deleteThisStreamer">удалить</button>
					<button class="btn btn-outline-dark" @click="cancel">отменить</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { performRequest } from "../script/ws/wsclient";
	import { mapMutations, mapGetters }   from "vuex";

	export default {
		name:    "DeleteStreamer",
		data() {
			return {
				key: ""
			};
		},
		props:   {
			deleteStreamer: Object
		},
		computed: {
			...mapGetters(["getViewUser"])
		},
		methods: {
			...mapMutations(["setStreamers"]),
			deleteThisStreamer() {
				performRequest({
						section: "tvcontent.streamer",
						name:    "deleteStreamer"
					}, {
						hostname: this.deleteStreamer.str,
						operator: this.deleteStreamer.oper
					},
					a => {
						if (a.code === 200) {
							performRequest({
								section: "tvcontent.streamer",
								name:    "getStreamerList"
							},
							{
								operator: this.getViewUser
							}, a => {
								if (a.code === 200) {
									this.setStreamers(a.data);
									this.$emit("deleteStreamer", false);
								} else {
									console.log("ошибка");
								}
							});

						}
					});

			},
			cancel() {
				this.$emit("cancelDeletePopup", false);
			}
		}
	};
</script>
<style scoped lang="scss">
	@import "~bootstrap/scss/bootstrap";
	div {
		display: flex;
	}
	.main {
		z-index: 1000;
		background-color: rgba(130, 130, 130, 0.27);
	}
	.popup {
		max-height: 200px;
	}
	.cont {
		margin-left: 50%;
		transform: translateX(-50%);
	}
	.btn {
		height: 32px;
	}
	.title {
		font-size: 1.1rem;
		margin-bottom: 1rem;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/DeleteStreamer.vue